var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({attrs:{"id":_vm.bindId}},'div',_vm.$attrs,false),_vm._l((_vm.options),function(option,index){return _c('FormButtonsSelectOption',{key:index,attrs:{"option":option,"next-step":option.value !== 'none' ? 3 : 5}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }